<template>
  <AlertModal
    open
    :title="__('Are you sure you want to delete this member?')"
    :description="member.name"
    :is-loading="member.isLoadingDelete"
    @cancel="handleCancelButtonClick"
    @continue="handleContinueButtonClick"
  />
</template>

<script setup>
  import { ref } from 'vue';
  import { useToast } from 'vue-toastification';
  import { __ } from '@/helpers';
  import { AlertModal } from '@/components/other/alert-modal';

  const props = defineProps({
    member: {
      type: Object,
      required: true
    }
  });

  const emits = defineEmits(['cancel', 'continue']);

  const toast = useToast();

  const isLoading = ref(false);

  function handleCancelButtonClick() {
    emits('cancel');
  }

  async function handleContinueButtonClick() {
    isLoading.value = true;

    try {
      const response = await axios.post(
        route('redesign.company.members.remove'),
        { member_id: props.member.id }
      );

      if (response?.data?.message) {
        toast.success(response.data.message);
      }

      emits('continue', props.member);
    } catch {
      toast.error(
        __('An unexpected error has occured. Please try again later.')
      );
    }

    isLoading.value = false;
  }
</script>
